module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_sorvete.33c7a6be.png";